import { CanAccess, Title } from 'react-admin';
import { ReactElement } from 'react';
import { Stack } from '@mui/material';
import { useDefineAppLocation } from '@react-admin/ra-navigation';
import ClicksByMerchantWidget from './Widget';

export default function ClicksByMerchantPage(): ReactElement {
  useDefineAppLocation('clicks.by_merchant');

  return (
    <>
      <Title title="Clicks By Merchant" />
      <Stack spacing={3} sx={{ mt: 2, mb: 4 }}>
        <CanAccess resource="clicks_by_merchants" action="list">
          <ClicksByMerchantWidget />
        </CanAccess>
      </Stack>
    </>
  );
}
